// Export all language files
import en from './en';
import fr from './fr';
import ar from './ar';

// Create a dictionary of all available languages
const translations = {
  en,
  fr,
  ar
};

export default translations;
